import { Injectable } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ExtendedCustomFormValidators } from '@shared/helpers';
import { GlobalMessageService, GlobalMessageType } from '@spartacus/core';
import { UserPasswordFacade } from '@spartacus/user';
import { BehaviorSubject, Observable } from 'rxjs';
import { tap } from 'rxjs/operators';

@Injectable()
export class CustomUpdatePasswordComponentService {
  form = new FormGroup(
    {
      newPassword: new FormControl('', {
        validators: [
          Validators.required,
          Validators.minLength(4),
          ExtendedCustomFormValidators.containsDigitCharacters,
          ExtendedCustomFormValidators.containsCharacters,
        ],
      }),
      newPasswordConfirm: new FormControl('', { validators: [Validators.required] }),
    },
    {
      validators: ExtendedCustomFormValidators.passwordsMustMatch('newPassword', 'newPasswordConfirm'),
    },
  );

  isUpdating$: Observable<boolean>;

  private busy$ = new BehaviorSubject(false);

  constructor(
    private userPasswordService: UserPasswordFacade,
    private globalMessageService: GlobalMessageService,
  ) {
    this.isUpdating$ = this.busy$.pipe(tap((state) => (state === true ? this.form.disable() : this.form.enable())));
  }

  updatePassword(): void {
    if (!this.form.valid) {
      this.form.markAllAsTouched();

      return;
    }

    this.busy$.next(true);

    const oldPassword = this.form.get('oldPassword')?.value;
    const newPassword = this.form.get('newPassword')?.value;

    this.userPasswordService.update(oldPassword, newPassword).subscribe({
      next: () => this.onSuccess(),
      error: () => this.onError(),
    });
  }

  /* В спартакусе есть навигация на роут 'home' */
  protected onSuccess(): void {
    this.globalMessageService.add({ raw: 'Пароль изменён успешно.' }, GlobalMessageType.MSG_TYPE_CONFIRMATION);
    this.busy$.next(false);
  }

  protected onError(): void {
    this.busy$.next(false);
    this.form.reset();
  }
}
